// you can type rafce to get template
import React from 'react'
import './about.css'

const About = () => {
  return (
    <section id='about' class="about section" >
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__content">
          <br />
          <p >
          As a Full Stack Developer, I am a natural problem-solver with a passion for creating innovative and visually stunning web applications. 
          </p>
          <br />
          <p>
          With a solid foundation in programming and web development, I have honed my skills in several front-end and back-end technologies, and I am constantly seeking new challenges to push myself to the next level. I believe in collaboration, continuous learning, and making a meaningful impact on the world through technology.With a passion for design and user experience, I strive to create beautiful and functional web applications that make a difference in people's lives. I am excited to join a team that values creativity, collaboration, and excellence, and where I can continue to learn and grow as a developer.
          </p>  
          <p id="user-detail-intro">Had good knowledge on tech stacks of JavaScript,React,NodeJs,ExpressJs and MongoDB.</p> 
        </div>
      </div>
    </section>
  )
}

export default About